'use strict';
var path = require('path');
var envHelper = require('./envHelper');
var prefix = '';

// 如果是 mockplus 的, 要到根目录下面去找
if (window.mockplus) {
  prefix = '/';
}

if (window.CDN && !envHelper.isIEOrEdge()) { // IE 下面不能使用 CDN，会导致图标不显示
  prefix = window.CDN;
}

// 开发的时候,到 dist/ 目录下面去找
if (window.isDev) {
  prefix = 'dist/';
}

/*  验证文件修改
 var sourceStr = "avatar(mobile).png@statusbar(android).png@statusbar(ios).png@top actionbar.png" +
 "@CheckMark.png@Dot.png@HLine_1.png@HRule.png@rectangleUp.png@roundRectangle.png@VLine_1.png" +
 "@ace, card, cards, game, hazard, heart, playing.png@aid, ambulance, bandage, bandaid, care, doctor.png@aid, capsule, care, chemistry, doctor, dose, drug.png@alcohol, beer, beverage, bottle, drink, glass.png@ambulance, care, chemistry, cure, doctor, dope.png@american, fast food, hamburger, line, meal.png@and, fruits, lemon, vegetables.png@angel, christmas, decoration, winter.png@appliance, bread, food, toast, toaster.png@apron, pocket.png@arrow, streamline, target.png@awareness ribbon, health, healthcare, hospital.png@badminton, birdie, racquetball, sport.png@bag, shopping, streamline.png@ball, baseball, game, sport, stick.png@ball, basketball, education, game, school, sport.png@ball, christmas, crystal, decoration, snow globe.png@ball, christmas, decoration, winter.png@ball, education, football, game, handball, school.png@ball, pool, rounded, sport.png@ball, rounded, soccer, sport.png@barbecue, eat, food, streamline.png@basic, bowling, game, play.png@bathroom, charming, clean up, paper, restroom.png@beaker, chemistry, health, healthcare, hospital.png@beauty in nature, cartoon, christmas, christmas.png@bee, honey, jar, sweet.png@bicycle, bike, biking, cycling, fitness, sport.png@bodybuilding, muscle, sport.png@bomb, bug.png@boot, christmas, decoration, sock, winter.png@bottle, drink, milk.png@bottle, food, honey, jar.png@brush, paint, streamline.png@business, chess, finance, financial, game, horse.png@cake, candy, christmas, cookies.png@camera, streamline, video.png@candle, christmas, decoration.png@candy, christmas, decoration, winter.png@candy, christmas, sweet.png@candy, lollipop, lollypop, sugar, sweet.png@capsule, care, chemistry, dose, drug, health.png@care, health, heart, medical, pulse.png@case, cross, doctor, health, healthcare, medicine.png@champion, gold, praise, reward, sport, winner.png@chaplin, hat, streamline.png@chess, game, piece, rook, strategy.png@chicken, drumstick, food.png@chips, deep-fried, fast, food, french, fries, potato.png@christmas, cold, freeze, frost, frozen, snow.png@christmas, crown, decoration, winter, wreath.png@christmas, deer, reindeer, rudolf, winter.png@christmas, sled, sledge, sleigh.png@christmas, snow, snowman, winter.png@claus, hat, santa.png@coffee, streamline.png@cold, cone, cream, ice.png@console, controller, game, tool.png@cream, dessert, food, ice.png@cup, tea.png@dashboard, speed, streamline.png@design, graphic tablet, streamline, tablet.png@dumbbell, kettlebell, sport, weight.png@earth, globe, streamline.png@education, football, game, play, school, soccer.png@envellope, mail, streamline.png@female,woman.png@first aid, medecine, shield, streamline.png@flash drive, memory stick, usb, usb key.png@food, hood, kitchen.png@fridge, refrigerator.png@google+.png@guitar, instrument, music.png@hair dryer, service, vacation.png@health, healthcare, hospital, medical, medicine.png@ink, pen, streamline.png@ipod, mini, music, streamline.png@ipod, music, streamline.png@japan, streamline, tea.png@knife, lettuce.png@machine, sewing.png@male,man.png@microwave, oven.png@music, radio.png@notebook, streamline.png@paint bucket, streamline.png@painting, roll, streamline.png@picture, streamline.png@receipt, shopping, streamline.png@remote control, streamline.png@settings, streamline.png@stamp, streamline.png";
 var targetStr = "avatar_mobile_.png@statusbar_android_.png@statusbar_ios_.png@top_actionbar.png" +
 "@checkmark.png@dot.png@hline_1.png@hrule.png@rectangleup.png@roundrectangle.png@vline_1.png" +
 "@ace_card_cards_game_hazard_heart_playing.png@aid_ambulance_bandage_bandaid_care_doctor.png@aid_capsule_care_chemistry_doctor_dose_drug.png@alcohol_beer_beverage_bottle_drink_glass.png@ambulance_care_chemistry_cure_doctor_dope.png@american_fast_food_hamburger_line_meal.png@and_fruits_lemon_vegetables.png@angel_christmas_decoration_winter.png@appliance_bread_food_toast_toaster.png@apron_pocket.png@arrow_streamline_target.png@awareness_ribbon_health_healthcare_hospital.png@badminton_birdie_racquetball_sport.png@bag_shopping_streamline.png@ball_baseball_game_sport_stick.png@ball_basketball_education_game_school_sport.png@ball_christmas_crystal_decoration_snow_globe.png@ball_christmas_decoration_winter.png@ball_education_football_game_handball_school.png@ball_pool_rounded_sport.png@ball_rounded_soccer_sport.png@barbecue_eat_food_streamline.png@basic_bowling_game_play.png@bathroom_charming_clean_up_paper_restroom.png@beaker_chemistry_health_healthcare_hospital.png@beauty_in_nature_cartoon_christmas_christmas.png@bee_honey_jar_sweet.png@bicycle_bike_biking_cycling_fitness_sport.png@bodybuilding_muscle_sport.png@bomb_bug.png@boot_christmas_decoration_sock_winter.png@bottle_drink_milk.png@bottle_food_honey_jar.png@brush_paint_streamline.png@business_chess_finance_financial_game_horse.png@cake_candy_christmas_cookies.png@camera_streamline_video.png@candle_christmas_decoration.png@candy_christmas_decoration_winter.png@candy_christmas_sweet.png@candy_lollipop_lollypop_sugar_sweet.png@capsule_care_chemistry_dose_drug_health.png@care_health_heart_medical_pulse.png@case_cross_doctor_health_healthcare_medicine.png@champion_gold_praise_reward_sport_winner.png@chaplin_hat_streamline.png@chess_game_piece_rook_strategy.png@chicken_drumstick_food.png@chips_deep_fried_fast_food_french_fries_potato.png@christmas_cold_freeze_frost_frozen_snow.png@christmas_crown_decoration_winter_wreath.png@christmas_deer_reindeer_rudolf_winter.png@christmas_sled_sledge_sleigh.png@christmas_snow_snowman_winter.png@claus_hat_santa.png@coffee_streamline.png@cold_cone_cream_ice.png@console_controller_game_tool.png@cream_dessert_food_ice.png@cup_tea.png@dashboard_speed_streamline.png@design_graphic_tablet_streamline_tablet.png@dumbbell_kettlebell_sport_weight.png@earth_globe_streamline.png@education_football_game_play_school_soccer.png@envellope_mail_streamline.png@female_woman.png@first_aid_medecine_shield_streamline.png@flash_drive_memory_stick_usb_usb_key.png@food_hood_kitchen.png@fridge_refrigerator.png@google_.png@guitar_instrument_music.png@hair_dryer_service_vacation.png@health_healthcare_hospital_medical_medicine.png@ink_pen_streamline.png@ipod_mini_music_streamline.png@ipod_music_streamline.png@japan_streamline_tea.png@knife_lettuce.png@machine_sewing.png@male_man.png@microwave_oven.png@music_radio.png@notebook_streamline.png@paint_bucket_streamline.png@painting_roll_streamline.png@picture_streamline.png@receipt_shopping_streamline.png@remote_control_streamline.png@settings_streamline.png@stamp_streamline.png";
 var source = sourceStr.split("@");
 var target = targetStr.split("@");
 var e = [];
 var pass = 0, error = 0;
 for(var i=0;i<source.length;i++) {
 if(target[i] == this.changeFile(source[i])) {
 pass++;
 }
 else {
 error++;
 e.push(source[i] + "->" + target[i]);
 }
 }*/
function changeFileName(name) {

  name = name.replace(/,|\s|\(|\)/g, '_');

  //去掉重复的下划线
  name = name.replace(/(_)_*\1/g, "_");

  if (name.indexOf('.png') === -1 && name.indexOf('.jpg') === -1) {
    name = name + ".png";
  }

  return name.toLowerCase();
}

/**
 * 根据资源的相对路径查找真实路径
 * @param p
 * @returns {string}
 */
exports.getAsset = function (p) {
  return path.join(prefix, 'assets', p);
};

/**
 * 获取组件的素材
 * @param name
 * @returns {string}
 */
exports.getComponentAsset = function (name) {
  if (!name) {
    return '';
  }
  name = changeFileName(name);
  return path.join(prefix, 'assets/components/wireframe/', name.toLowerCase()); // 这里始终使用线框素材
};

/**
 * 获取图标
 * @param filename
 * @returns {string}
 */
exports.getIcon = function (filename) {
  if (!filename) {
    return '';
  }
  filename = changeFileName(filename);
  return path.join(prefix, 'assets/icons/wireframe/', filename.toLowerCase()); // 始终使用线框图标
};

/**
 * 获取辅助素材资源
 * @param filename
 * @returns {string}
 */
exports.getAssistAsset = function (filename) {
  if (!filename) {
    return '';
  }
  filename = changeFileName(filename);
  return path.join(prefix, 'assets/components/wireframe/commons/', filename.toLowerCase());
};

exports.getLogo = function () {
  return path.join(prefix, 'assets/logo.png');
};



// WEBPACK FOOTER //
// ./src/helper/assetsHelper.js